import { ROLES, setRoles } from "./role.config";

export const DynamicAsideMenuConfig = {
  items: [
    {
      title: 'Academia Online',
      root: true,
      icon: 'flaticon2-laptop',
      svg: './assets/media/svg/icons/Devices/Laptop.svg',
      page: 'https://online.preuteslaplus.com/',
      translate: 'Academia Online',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO, ROLES.PROFESOR, ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.APODERADO, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
      external: true
    },
    { section: 'Impresiones', permission: setRoles([ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.ADMINISTRADOR]) },
    {
      title: 'Impresiones',
      root: true,
      icon: 'flaticon2-print',
      svg: './assets/media/svg/icons/Home/Book-open.svg',
      bullet: 'dot',
      permission: setRoles([ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.ADMINISTRADOR]),
      submenu: [
        { permission: setRoles([ROLES.IMPRESIONES, ROLES.ADMINISTRADOR]), page: '/printing/global', title: 'Planificación Global' },
        { permission: setRoles([ROLES.IMPRESIONES, ROLES.ADMINISTRADOR]), page: '/printing/distribution', title: 'Distribución' },
        { permission: setRoles([ROLES.IMPRESIONESSEDE]), page: '/printing/campus', title: 'Planificación Sede' },
        { permission: setRoles([ROLES.IMPRESIONESSEDE]), page: '/printing/tracking', title: 'Seguimiento de Guías' },
        { permission: setRoles([ROLES.IMPRESIONESSEDE]), page: '/printing/campus-distribution', title: 'Distribución a Profesores' },
        { permission: setRoles([ROLES.IMPRESIONESSEDE]), page: '/printing/pending', title: 'Entregas Pendientes' },
      ]
    },
    { section: 'Calendario', permission: setRoles([ROLES.ALUMNO, ROLES.PROFESOR, ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.APODERADO, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.COORDINADORDESEDE]) },
    {
      title: 'Calendario',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      page: '/schedules-available/students/elections',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO])
    },
    {
      title: 'Calendario',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      page: '/schedules-available/parents',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.APODERADO])
    },
    {
      title: 'Calendario',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      page: '/users/subjects',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.RECEPCIONISTA, ROLES.COORDINADORDESEDE])
    },
    // TODO: POR SI LO PIDEN ES SOLO DESCOMENTAR
    // {
    //   title: 'Calendario',
    //   root: true,
    //   icon: 'flaticon2-architecture-and-city',
    //   svg: './assets/media/svg/icons/Design/Layers.svg',
    //   page: '/schedules-available/admin',
    //   translate: 'MENU.DASHBOARD',
    //   bullet: 'dot',
    //   permission: setRoles([ROLES.INSTITUTO])
    // },
    {
      title: 'Clases',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Home/Book.svg',
      page: '/calendar/class',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO, ROLES.PROFESOR, ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA]),
    },
    {
      title: 'Horario Maestro',
      root: true,
      icon: 'flaticon2-calendar-8',
      svg: './assets/media/svg/icons/Code/Time-schedule.svg',
      page: '/schedules-available/master-schedule',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.RECEPCIONISTA, ROLES.ADMINISTRADOR]),
    },
    {
      title: 'Guías',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Home/Book.svg',
      page: '/guides/gallery',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO, ROLES.PROFESOR]),
    },
    {
      title: 'Clases Particulares',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Communication/Send.svg',
      page: '/calendar/private',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO, ROLES.PROFESOR, ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
    },
    {
      title: 'Mi Disponibilidad',
      root: true,
      icon: 'flaticon2-calendar-8',
      svg: './assets/plugins/keenthemes-icons/svg/065-calendar.svg',
      page: '/schedules-available/professor-availability',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.PROFESOR]),
    },
    { section: 'Exámenes', permission: setRoles([ROLES.APODERADO, ROLES.ALUMNO, ROLES.PROFESOR, ROLES.ADMINISTRADOR, ROLES.INSTITUTO,  ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE ]), coordinador: setRoles([ROLES.VENDEDOR]) },
    {
      title: 'Exámenes',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Home/Book-open.svg',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
      coordinador: setRoles([ROLES.VENDEDOR]),
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR]),
          page: '/exams/grades', title: 'Calificadores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/exams', title: 'Online', openInNewTab: true
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/exams/essay-categories', title: 'Categorías Ensayos'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/exams/in-person', title: 'Presencial'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/exams/in-person-exam-schedule', title: 'Bloque de Horario de Ensayo'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/exams/professor-exam-enrollment', title: 'Inscripción Ensayos'
        },
      ]
    },
    {
      title: 'Estadísticas',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      page: '/exams/stats/professor',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.PROFESOR]),
    },
    {
      title: 'Estadísticas',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      page: '/exams/stats/institute',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.INSTITUTO]),
    },
    {
      title: 'Online',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Code/Puzzle.svg',
      page: '/exams/students', 
      openInNewTab: true,
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO]),
    },
    {
      title: 'Inscripción Ensayos',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Home/Book-edit.svg',
      page: '/exams/student-exam-enrollment-calendar',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO]),
    },
    {
      title: 'Estadísticas',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      page: '/exams/stats',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.APODERADO, ROLES.ALUMNO]),
    },

    { section: 'Mis Solicitudes', permission: setRoles([ROLES.ALUMNO]) },
    {
      title: 'Certificado Alumno Regular',
      root: true,
      icon: 'flaticon2-file',
      svg: './assets/media/svg/icons/General/Certificate.svg',
      page: '/student-certificate',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO]),
    },
    {
      title: 'Soporte',
      root: true,
      icon: 'flaticon2-chat-1',
      svg: './assets/media/svg/icons/Code/Question-circle.svg',
      page: '/support',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO]),
    },

    { section: 'Usuarios', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.COORDINADORGENERAL, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.RECEPCIONISTA, ROLES.COORDINADORDESEDE]) },
    {
      title: 'Usuarios',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/General/User.svg',
      root: false,
      translate: 'MENU.DASHBOARD',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.RECEPCIONISTA, ROLES.COORDINADORDESEDE]),
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/parents', title: 'Apoderados'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.RECEPCIONISTA, ROLES.COORDINADORDESEDE]),
          page: '/users/students', title: 'Alumnos'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/professors', title: 'Profesores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/directors', title: 'Director de Sede'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/institutos', title: 'Coordinador de Instituciones'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/sellers', title: 'Vendedores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/users/admins', title: 'Administradores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/secretaries', title: 'Recepcionistas'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/printing', title: 'Impresiones'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
          page: '/users/ambassadors', title: 'Embajadores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
          page: '/users/auditors', title: 'Auditores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
          page: '/users/accountant-chief', title: 'Jefes de Contabilidad'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/users/sales-chief', title: 'Jefes de Ventas'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/campus-responsables', title: 'Coordinador de Sede'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/users/academic-gestor', title: 'Gestor Académico'
        }
      ]
    },
    {
      title: 'Carga masiva',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Files/Import.svg',
      root: true,
      translate: 'MENU.DASHBOARD',
      permission: setRoles([ROLES.ADMINISTRADOR]),
      page: '/users/students/massive-form',
    },
    {
      title: 'Cursos',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Home/Library.svg',
      root: true,
      translate: 'MENU.DASHBOARD',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORGENERAL, ROLES.INSTITUTO, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
      page: '/users/courses',
    },

    { section: 'Asistencias', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.APODERADO, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE]) },
    {
      title: 'Estudiantes',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/General/User.svg',
      page: '/assistances/admin',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE]),
    },
    {
      title: 'Hijos',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/General/User.svg',
      page: '/assistances/parents',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.APODERADO]),
    },
    {
      title: 'Profesores',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      page: '/assistances/professors',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
    },


    { section: 'Gestión Académica', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]) },
    {
      title: 'Ranking de Profesores',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      page: '/academic-management/professor-ranking',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
    },
    // {
    //   title: 'Evaluación de Desempeño',
    //   root: true,
    //   icon: 'flaticon2-architecture-and-city',
    //   svg: './assets/media/svg/icons/Home/Book-open.svg',
    //   page: '/academic-management/professor-evaluation',
    //   translate: 'MENU.DASHBOARD',
    //   bullet: 'dot',
    //   permission: setRoles([ROLES.PROFESOR]),
    // },
    {
      title: 'Carga Horaria',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Code/Time-schedule.svg',
      page: '/academic-management/schedule-hours',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
    },
    {
      title: 'Evaluación de Profesores',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Home/Book-open.svg',
      page: '',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
          page: '/academic-management/admin-evaluation-report', title: 'Valoraciones'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/academic-management/professor-valuation', title: 'Valoración de Profesores'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORDESEDE]),
          page: '/academic-management/lectionary-report', title: 'Llenado Leccionario'
        },
      ],
    },
    {
      title: 'Configuración',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/General/Settings-2.svg',
      root: true,
      translate: 'MENU.DASHBOARD',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
      page: '',
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/academic-management/time-between-campuses', title: 'Tiempo entre Sedes'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/academic-management/ranking-criteria', title: 'Criterio de Ranking'
        },
      ],
    },


    { section: 'Encuestas', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.ALUMNO]) },
    {
      title: 'Gestión de Encuestas',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Communication/Clipboard-list.svg',
      page: '/surveys/gestion',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR]),
    },
    {
      title: 'Encuestas Lanzadas',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Media/Play.svg',
      page: '/surveys/launched',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR]),
    },
    {
      title: 'Encuestas Disponibles',
      root: true,
      icon: 'flaticon2-architecture-and-city',
      svg: './assets/media/svg/icons/Communication/Clipboard-check.svg',
      page: '/surveys/student-list',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ALUMNO]),
    },


    { section: 'Contabilidad', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.PROFESOR, ROLES.APODERADO, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]) },
    {
      title: 'Finanzas',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Dollar.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.PROFESOR, ROLES.APODERADO, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
      page: '',
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/block-prices', title: 'Precios'
        },
        {
          title: 'Descuentos',
          bullet: 'dot',
          root: true,
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '',
          submenu: [
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/discounts/blocks', title: 'Descuentos en Bloques'
            },
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/discounts/sale', title: 'Descuentos en Ventas'
            },
            {
              permission: setRoles([ROLES.ADMINISTRADOR]),
              page: '/discounts/coupon', title: 'Cupones de Descuento'
            },
          ],
        },
        {
          title: 'Ventas',
          bullet: 'dot',
          root: true,
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '',
          submenu: [
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/sales/leads', title: 'Leads'
            },
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/sales/hot-leads', title: 'Hot Leads'
            },
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/sales/online', title: 'Online'
            },
            {
              permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
              page: '/sales/done', title: 'Realizadas'
            },
          ],
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/payments', title: 'Pagos de Apoderados'
        },
        {
          permission: setRoles([ROLES.APODERADO]),
          page: '/payments/parents', title: 'Pagos'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.PROFESOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/payouts', title: 'Cobros'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.VENDEDOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/debts', title: 'Deudas'
        },
      ]
    },

    { section: 'Panel Embajador', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.AFILIADO]) },
    {
      title: 'Perfil',
      bullet: 'dot',
      icon: 'flaticon2-user',
      svg: './assets/media/svg/icons/General/User.svg',
      root: true,
      permission: setRoles([ROLES.AFILIADO]),
      page: '/user-profile/profile-overview',
    },
    {
      title: 'Leads y Matrículas',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      root: true,
      permission: setRoles([ROLES.AFILIADO]),
      page: '/affiliate-leads',
    },
    {
      title: 'Materiales',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Files/Media-folder.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR]),
      page: '/ambassador/brand-materials',
    },

    { section: 'Flujo de Caja', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR, ROLES.JEFEVENTAS]) },
    {
      title: 'Dashboard',
      bullet: 'dot',
      icon: 'flaticon2-analytics',
      svg: './assets/media/svg/icons/Shopping/Chart-line1.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR, ROLES.JEFEVENTAS]),
      hiddenFor: setRoles([ROLES.JEFECONTABILIDAD, ROLES.AUDITOR, ROLES.JEFEVENTAS]),
      page: '/cash-flow/dashboard'
    },
    {
      title: 'Ingresos',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Dollar.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR, ROLES.JEFEVENTAS]),
      page: '/cash-flow/income'
    },
    {
      title: 'Gastos',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Dollar.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]),
      page: '/cash-flow/expenses'
    },
    {
      title: 'Configuración',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/General/Settings-2.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]),
      page: '',
      submenu: [
        { permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]), page: '/cash-flow/categories', title: 'Categorías' },
        { permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]), page: '/cash-flow/subcategories', title: 'Subcategorías' },
        { permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]), page: '/cash-flow/business-units', title: 'Unidades de Negocio' },
        { permission: setRoles([ROLES.ADMINISTRADOR, ROLES.JEFECONTABILIDAD, ROLES.AUDITOR]), page: '/cash-flow/financial-institutions', title: 'Instituciones Financieras' }
      ]
    },

    { section: 'Soporte', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]) },
    {
      title: 'Gestión de Solicitudes',
      root: true,
      icon: 'flaticon2-chat-1',
      svg: './assets/media/svg/icons/Code/Question-circle.svg',
      page: '/support/admin',
      translate: 'MENU.DASHBOARD',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
    },
    {
      title: 'Salud del Sitio',
      root: true,
      icon: 'flaticon2-shield',
      svg: './assets/media/svg/icons/General/Shield-check.svg',
      page: '/site-health',
      bullet: 'dot',
      permission: setRoles([ROLES.ADMINISTRADOR]),
    },

    { section: 'Configuración de Calendario', permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.PROFESOR, ROLES.DIRECTOR, ROLES.COORDINADORGENERAL, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]) },
    {
      title: 'Configuración',
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/General/Settings-2.svg',
      root: true,
      permission: setRoles([ROLES.ADMINISTRADOR, ROLES.RECEPCIONISTA, ROLES.VENDEDOR, ROLES.PROFESOR, ROLES.DIRECTOR, ROLES.COORDINADORGENERAL, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
      page: '',
      submenu: [
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/campus', title: 'Sedes'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/rooms', title: 'Salas'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.INSTITUTO, ROLES.COORDINADORDESEDE]),
          page: '/block-movement-history', title: 'Intercambios de secciones'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR]),
          page: '/campus-migration', title: 'Migración de Alumnos'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/course-types', title: 'Modalidades'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORGENERAL, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/courses', title: 'Año Académico'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/categories', title: 'Categorias'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/subjects', title: 'Ramos'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/packs', title: 'Packs'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.GESTORACADEMICO]),
          page: '/topics', title: 'Temas'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
          page: '/guides', title: 'Guías'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/contract-docs', title: 'Documentos de Contrato'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/gift-lessons', title: 'Clases particulares de regalo'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORGENERAL, ROLES.DIRECTOR, ROLES.COORDINADORDESEDE]),
          page: '/sections', title: 'Secciones'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORGENERAL]),
          page: '/hours', title: 'Bloque Horario'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.COORDINADORGENERAL, ROLES.DIRECTOR, ROLES.RECEPCIONISTA, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
          page: '/schedules', title: 'Calendario'
        },
        {
          permission: setRoles([ ROLES.PROFESOR, ROLES.COORDINADORGENERAL]),
          page: '/schedules-available/admin', title: 'Calendario'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR, ROLES.DIRECTOR, ROLES.IMPRESIONES, ROLES.IMPRESIONESSEDE, ROLES.RECEPCIONISTA, ROLES.COORDINADORDESEDE, ROLES.GESTORACADEMICO]),
          page: '/schedules-available/holidays', title: 'Calendario Feriados'
        },
        {
          permission: setRoles([ROLES.ADMINISTRADOR]),
          page: '/settings', title: 'Configuraciones Especiales'
        },
      ]
    },
  ]
};
